import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import parse from 'html-react-parser';

import { SchedulerEditor } from 'components/Scheduler';
import { LandingContent } from 'components/LandingContent';

import SchedulerLandingImage from 'assets/images/scheduler-landing-1.jpeg';

import './scheduler-editor-page.scss';
import useConnectModal from 'components/ConnectModal';
import { getSchedulerConfigs } from 'api/scheduler';
import { Loading } from 'components/Loading';

const SchedulerEditorPage = () => {
  const [noActiveSchedule, setNoActiveSchedule] = useState(true);
  const [loading, setLoading] = useState(true);
  const userInfo = useSelector(state => state.global.userInfo);
  const {
    deleteRedirectPath,
    setConnectedModalOpen,
    setConnectModalOpen,
    setNotEnabledOpen,
    setRedirectPath,
    ConnectModal,
  } = useConnectModal();

  const { personas } = userInfo || {};
  const { integratedStatus } = personas;

  const modalTitle = 'Meet your new assistant.';

  const modalDescription = parse(
    'Scheduling meetings just got easier with Aisle Planner\'s Scheduling Assistant, powered by AP Connect.' +
      ' Create and share scheduling pages to easily book meetings and events based on your availability. ' +
      '<a target="_blank" href="' +
      'https://help.aisleplanner.com/en/articles/9981556-calendar-integration-scheduling-assistant' +
      '">Learn more here.</a>',
  );

  const actionText = 'GET CONNECTED';

  useEffect(() => {
    async function checkScheduler() {
      const response = await getSchedulerConfigs();
      if (response.data.length > 0) {
        setNoActiveSchedule(false);
      }
      setLoading(false);
    }

    checkScheduler();

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('connected') === 'true') {
      // If we've just connected
      // show the assistant
      setNoActiveSchedule(false);
      setConnectedModalOpen(true);
      // Remove the query param from the URL
      const newUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, newUrl);
      // Delete the cookie
      deleteRedirectPath();
    }
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (integratedStatus === 'disabled') {
    return (
      <div className="content-container">
        <LandingContent
          title={modalTitle}
          description={modalDescription}
          actionButtonTitle={actionText}
          action={() => setNotEnabledOpen(true)}
          heroImage={SchedulerLandingImage}
        />
        <ConnectModal />
      </div>
    );
  }
  if (integratedStatus === 'disconnected') {
    return (
      <div className="content-container">
        <LandingContent
          title={modalTitle}
          description={modalDescription}
          actionButtonTitle={actionText}
          action={() => {
            setConnectModalOpen(true);
            setRedirectPath(`${document.location.pathname}?connected=true`);
          }}
          heroImage={SchedulerLandingImage}
        />
        <ConnectModal />
      </div>
    );
  }
  if (integratedStatus === 'connected' && noActiveSchedule) {
    return (
      <div className="content-container">
        <LandingContent
          title={modalTitle}
          description={modalDescription}
          actionButtonTitle={'LET\'S GET STARTED'}
          action={() => setNoActiveSchedule(false)}
          heroImage={SchedulerLandingImage}
        />
        <ConnectModal />
      </div>
    );
  }
  return (
    <div className="container container--scheduler-editor">
      <section className="page-title">
        <h1 className="title">Scheduling Assistant</h1>
      </section>
      <SchedulerEditor />
      <ConnectModal />
    </div>
  );
};

export default SchedulerEditorPage;
